import React from 'react'

import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import { withRouter } from 'react-router-dom'
import storage from 'utils/storage'
import isDOMAvailable from 'utils/isDOMAvailable'
import { lockScroll, unlockScroll } from 'utils/bodyScrollLock'
import addMinutes from 'date-fns/addMinutes'

import Header from 'components/header/Header'
import NewHeader from 'components/newHeader/NewHeader'
import HeaderWrapper from 'components/newHeader/HeaderWrapper'
import HeaderCustom from 'components/newHeader/HeaderCustom'
import StickyMobileMenu from 'components/newHeader/StickyMobileMenu'
import MobileFullscreenMenu from 'components/newHeader/MobileFullscreenMenu'
import Container from 'components/atoms/Container'
import Sticky from 'components/atoms/Sticky'
import Footer from 'components/organisms/Footer'
import StickySectionNav from 'components/organisms/StickySectionNav'
import CompleteSignUpNotice from 'components/molecules/CompleteSignUpNotice'
import Breadcrumb from 'components/molecules/Breadcrumb'
import BackToTop from 'components/molecules/BackToTop'
import PopupSignup from 'components/organisms/PopupSignup'

import scrollTo from 'utils/ui/scrollTo'
import API from 'utils/API'
import LayoutContext from 'utils/ui/LayoutContext'
import triggerEvent from 'utils/dataLayer'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

import smoothscroll from 'smoothscroll-polyfill'
import { NotificationProvider } from 'components/notifications/NotificationProvider'
import NotificationPopup from 'components/notifications/organisms/NotificationPopup'

if (typeof window !== 'undefined') {
  smoothscroll.polyfill()
  window.__forceSmoothScrollPolyfill__ = true
}

class BaseTemplate extends React.Component {
  state = {
    showBackToTop: false,
    showStickyBottom: false,
    showNavbarAction: false,
    showSignupPopup: false,
    stickyHeight: 0,
    navbarHeight: 0,
    likeBtnHeight: 0,
    fixedNavbar: true,
    prevScrollPost: 0,
    activeMenu: 'idle',
    popUpSignupTop: 0,
  }

  componentDidMount() {
    scrollTo('top')

    // back to top button functionality
    const { useBackToTop, firstSection, useStickyBottom, currentUser } = this.props

    if (isDOMAvailable) {
      const navbarHeightVal = document.querySelector('.navbar') && document.querySelector('.navbar').offsetHeight

      this.setState({
        navbarHeight: navbarHeightVal,
      })

      window.addEventListener('scroll', () => {
        const { prevScrollPost, navbarHeight } = this.state
        const fixedNavbar = prevScrollPost > window.scrollY
        if (window.scrollY > navbarHeight) {
          this.setState({
            prevScrollPost: window.scrollY,
            fixedNavbar,
          })
        }
      })
      this.setActiveMenuByPath()
    }

    if (isDOMAvailable && Object.keys(this.props.actionContent).length !== 0) {
      const likeBtnHeightVal =  document.querySelector('.like-button--complete') &&
        (document.querySelector('.like-button--complete').offsetHeight + document.querySelector('.like-button--complete').offsetTop)

      this.setState({ likeBtnHeight: likeBtnHeightVal })

      window.addEventListener('scroll', () => {
        const { likeBtnHeight } = this.state
        if (window.scrollY > likeBtnHeight) {
          this.setState({ showNavbarAction: true })
        } else {
          this.setState({ showNavbarAction: false })
        }
      })
    }

    if (isDOMAvailable && useBackToTop) {
      const { showBackToTop } = this.state
      const { backToTopPostAdjusment } = this.props
      const footerEl = document.getElementById('Footer')

      const positionToAppear = footerEl ? footerEl.offsetTop - (footerEl.offsetHeight + window.innerHeight + backToTopPostAdjusment) : 0

      window.addEventListener('scroll', () => {
        if (window.scrollY > positionToAppear) {
          !showBackToTop && this.setState({
            showBackToTop: true,
          })
        } else {
          this.setState({
            showBackToTop: false,
          })
        }
      })
    }

    if (isDOMAvailable && useStickyBottom) {
      const { showStickyBottom } = this.state
      const positionToAppear = document.querySelector(firstSection) &&
        document.querySelector(firstSection).offsetHeight

      window.addEventListener('scroll', () => {
        if (window.scrollY > positionToAppear) {
          !showStickyBottom && this.setState({
            showStickyBottom: true,
          }, () => {
            this.setMarginBottom()
          })
        } else {
          this.setState({
            showStickyBottom: false,
          })
        }
      })
    }

    const popUpSignupStatus = localStorage.getItem('popUpSignupStatus')
    if (currentUser) {
      popUpSignupStatus !== 'disabled' && localStorage.setItem('popUpSignupStatus', 'disabled')
    } else {
      // init pop up when status is null or after user logout
      (!popUpSignupStatus || popUpSignupStatus === 'disabled') && this.initPopupSignup()

      const timer = setInterval(() => {
        const currentPopupStatus = localStorage.getItem('popUpSignupStatus')
        const currentPopupTime = localStorage.getItem('popUpSignupTime')

        if (currentPopupStatus !== 'enabled') {
          clearInterval(timer)
        } else if (parseInt(currentPopupTime, 10) < new Date().getTime() && !document.hidden) {
          this.openPopupSignup()
        }
      }, 5000)
    }
  }

  // Todo: componentWillUpdate will be deprecated on react 17
  componentWillUpdate(newProps) {
    if (newProps.match.url !== this.props.match.url) {
      storage.set('commonProps', { isLoading: true })

      API.get(`${newProps.match.url}.json`).then((response) => {
        const fetchedProps = {
          serverProps: response.data,
          commonProps: { isLoading: false },
        }

        storage.deepMerge(fetchedProps)
      })
    }
  }

  initPopupSignup = () => {
    localStorage.setItem('popUpSignupTime', addMinutes(new Date(), 2).getTime().toString())
    localStorage.setItem('popUpSignupStatus', 'enabled')
  }

  openPopupSignup = () => {
    localStorage.setItem('popUpSignupStatus', 'hasOpen')
    this.setState({ showSignupPopup: true, popUpSignupTop: window.scrollY })
    triggerEvent('popup', { popup_action: 'show', page_location: window.location.pathname })
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
    lockScroll()
  }

  setMarginBottom = () => {
    const stickyHeight = document.querySelector('.sticky').offsetHeight
    this.setState({
      stickyHeight,
    })
  }

  setActiveMenu = (val) => {
    this.setState({ activeMenu: val })
  }

  setActiveMenuByPath = () => {
    const pathname = window.location.pathname
    if (pathname.indexOf('/likes/') !== -1) {
      this.setActiveMenu('favourite')
    } else if (pathname === '/aptitude_test/history') {
      this.setActiveMenu('assessment-history')
    } else if (new RegExp(/^\/(directory|majors|careers|scholarships|tests|partners|peluang-sbmptn|aptitude_test|locations|fields-of-study).*$/).test(pathname)) {
      this.setActiveMenu('directory-page')
    } else if (new RegExp(/^\/(profile|recommended-campus).*$/).test(pathname)) {
      this.setActiveMenu('profile-page')
    } else {
      this.setActiveMenu('idle')
    }
  }

  setActiveMenuToggle = (menuType) => {
    if (menuType === this.state.activeMenu) {
      this.setActiveMenuByPath()
      if (window.scrollY === 0) {
        this.setState({ fixedNavbar: true })
      }
    } else {
      this.setActiveMenu(menuType)
    }
  }

  closePopupSignup = () => {
    triggerEvent('popup', { popup_action: 'close', page_location: window.location.pathname })
    this.setState({ showSignupPopup: false })
    unlockScroll()
  }

  checkNotifPage = () => {
    const pathname = window.location.pathname
    return new RegExp(/^\/(profile|likes|report).*$/).test(pathname)
  }

  render() {
    const {
      noBreadcrumb,
      breadcrumbs,
      sections,
      topSection,
      stickyBottomContent,
      children,
      currentUser,
      useNewHeader,
      useCTABottom,
      useNewBreadcrumb,
      actionContent,
    } = this.props
    const {
      activeMenu,
      showBackToTop,
      showStickyBottom,
      navbarHeight,
      stickyHeight,
      fixedNavbar,
      showNavbarAction,
      showSignupPopup,
      popUpSignupTop,
    } = this.state

    const showCustomNavbar = new RegExp(/^(directory|profile)$/).test(activeMenu)
    return (
      <NotificationProvider>
        <LayoutContext.Provider value={{ fixedNavbar, navbarHeight }} >
          <div id="BaseTemplate">
            {
              showSignupPopup && <PopupSignup close={() => this.closePopupSignup()} top={popUpSignupTop} />
            }
            {
              useNewHeader && showCustomNavbar &&
                <HeaderWrapper>
                  <HeaderCustom title={activeMenu === 'directory' ? 'Direktori' : 'Profil'} />
                </HeaderWrapper>
            }
            {useNewHeader && !showCustomNavbar && <NewHeader
              actionContent={(showNavbarAction && actionContent) || {}}
              hideMobileNotification={!this.checkNotifPage()}
              showMobileNotification={() => this.setActiveMenu('notification')}
            />
            }
            {!useNewHeader && <Header fixed={fixedNavbar} />}
            {activeMenu === 'notification' && <NotificationPopup close={() => this.setActiveMenu('idle')} />}
            {activeMenu === 'directory' && <MobileFullscreenMenu source="directory" />}
            {activeMenu === 'profile' && <MobileFullscreenMenu source={currentUser ? 'profileAuthorized' : 'profileUnauthorized'} />}
            {
              sections &&
              <StickySectionNav
                sections={sections}
                afterElement={topSection}
                topOffset={fixedNavbar ? navbarHeight : 0}
              />
            }
            {
              !noBreadcrumb &&
              <Breadcrumb paths={breadcrumbs} />
            }
            {children}
            <CompleteSignUpNotice/>
            { showBackToTop && <BackToTop/> }
            { showStickyBottom && (
              <Sticky useMobileButton>
                <Container>
                  { stickyBottomContent }
                </Container>
              </Sticky>
            )}
            <Footer />
            { useNewHeader && <StickyMobileMenu setActiveMenu={this.setActiveMenuToggle} activeMenu={activeMenu}/> }
            <style jsx>
              {`
                #BaseTemplate {
                  margin-top: ${showSignupPopup ? '0' : navbarHeight}px;
                  @media screen and (min-width: 768px) {
                    padding-bottom: ${stickyHeight}px;
                    :global(.Breadcrumb) {
                      max-width: ${useNewBreadcrumb ? '1205px' : '940px'};
                    }
                  }
                  :global(#Footer) {
                    @media screen and (max-width: 767px) {
                      padding-bottom: ${useNewHeader ? '56px' : '0'};
                    }
                  }
                  :global(.back-to-top) {
                    @media screen and (max-width: 767px) {
                      bottom: ${useCTABottom ? '124px' : '80px'};
                    }
                  }

                }
            `}
            </style>
          </div>
        </LayoutContext.Provider>
      </NotificationProvider>
    )
  }
}

BaseTemplate.propTypes = {
  noBreadcrumb: PropTypes.bool,
  breadcrumbs: PropTypes.array,
  sections: PropTypes.array,
  topSection: PropTypes.string,
  firstSection: PropTypes.string,
  useBackToTop: PropTypes.bool,
  useStickyBottom: PropTypes.bool,
  stickyBottomContent: PropTypes.element,
  backToTopPostAdjusment: PropTypes.number,
  currentUser: PropTypes.object,
  useNewHeader: PropTypes.bool,
  useNewBreadcrumb: PropTypes.bool,
  useCTABottom: PropTypes.bool,
  actionContent: PropTypes.shape({
    likeStatus: PropTypes.bool,
    likeTarget: PropTypes.string,
    kind: PropTypes.string,
    type: ActionTypeProp,
    targetName: PropTypes.string,
    shareTitle: PropTypes.string,
    shareText: PropTypes.string,
  }),
}

BaseTemplate.defaultProps = {
  breadcrumbs: [],
  noBreadcrumb: false,
  firstSection: '.campus-page-banner',
  backToTopPostAdjusment: 0,
  useNewHeader: false,
  useCTABottom: false,
  useNewBreadcrumb: false,
  actionContent: {},
}

const BaseTemplateWithRouter = withRouter(BaseTemplate)

export default branch({
  breadcrumbs: ['serverProps', 'breadcrumbs'],
  currentUser: ['serverProps', 'currentUser'],
}, BaseTemplateWithRouter)
